export const DEAL_STAGES = [
  { value: "sourcing", label: "Sourcing", color: "slate" },
  { value: "screening", label: "Screening", color: "blue" },
  { value: "due_diligence", label: "Due Diligence", color: "indigo" },
  { value: "ic_review", label: "IC Review", color: "purple" },
  { value: "negotiation", label: "Negotiation", color: "amber" },
  { value: "closing", label: "Closing", color: "green" },
  { value: "passed", label: "Passed / Declined", color: "red" },
] as const;

export type DealStage = (typeof DEAL_STAGES)[number]["value"];

export const STAGE_LABELS: Record<string, string> = Object.fromEntries(
  DEAL_STAGES.map((s) => [s.value, s.label])
);

export const STAGE_BADGE_COLORS: Record<string, string> = {
  sourcing: "bg-slate-500/10 text-slate-600 dark:text-slate-400",
  screening: "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  due_diligence: "bg-indigo-500/10 text-indigo-600 dark:text-indigo-400",
  ic_review: "bg-purple-500/10 text-purple-600 dark:text-purple-400",
  negotiation: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  closing: "bg-green-500/10 text-green-600 dark:text-green-400",
  passed: "bg-red-500/10 text-red-600 dark:text-red-400",
};

export const STAGE_DOT_COLORS: Record<string, string> = {
  sourcing: "bg-slate-500",
  screening: "bg-blue-500",
  due_diligence: "bg-indigo-500",
  ic_review: "bg-purple-500",
  negotiation: "bg-amber-500",
  closing: "bg-green-500",
  passed: "bg-red-500",
};

/** Map legacy stage values to new unified stages */
export function normalizeLegacyStage(stage: string): DealStage {
  const map: Record<string, DealStage> = {
    // Old 5-stage pipeline
    prospect: "sourcing",
    engaged: "screening",
    closed: "closing",
    lost: "passed",
    // Old 10-stage pipeline
    deal_sourcing: "sourcing",
    investment_committee: "ic_review",
    term_sheet: "negotiation",
    legal_diligence: "due_diligence",
    post_investment: "closing",
  };
  return map[stage] || (DEAL_STAGES.some((s) => s.value === stage) ? (stage as DealStage) : "sourcing");
}

export function formatDealSize(value?: number | null): string {
  if (!value) return "\u2014";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);
}
